import React, { Component } from 'react';
import { CardButton } from './CardButton';
import { CardButtonDescription } from './CardButtonDescription';


export class DefenseBox extends Component {

  render() {

    return (
      <div className="CardBox">
        <div className="CardBoxTitleOuter">
          <p className="CardBoxTitle">
            Defensive Strategy
          </p>
					<p className="CardBoxTitle CardBoxSubtitle">
            The best offense is... defense?
          </p>
        </div>

        <div className="CardBoxContainer">

					<div className="CardBoxBackground DefensiveBoxBackground" />
					<div className="CardBoxTint" />

					<CardButtonDescription rarity="archetypeDescription"
											titleBackground="rareTitle"
											cardTitle={ "pressure" }
											className="pressure"
											cardBackground="bandit legendaryBackground"
											archetypeName="pressure"
											text="Science says pressure = nRT/V, but the King&#8217;s therapist says the pressure is negatively impacting his health. Keep pressuring your opponent so they never have a chance to mount a decent attack!"
											color="redDescription"/>
					<div className="cardConnector"/>
          <CardButton rarity="rare"
											titleBackground="rareTitle"
											cardTitle={ "pressure" }
											className="pressure"
											cardBackground="bandit legendaryBackground"
											archetypeName="pressure" />

          <CardButton rarity="epic"
											titleBackground="epicTitle"
											cardTitle={ "punisher" }
											className="punisher"
											cardBackground="skeleton-barrel"
											archetypeName="punisher" />
					<div className="cardConnector"/>
					<CardButtonDescription rarity="archetypeDescription"
											titleBackground="rareTitle"
											cardTitle={ "punisher" }
											className="punisher"
											cardBackground="skeleton-barrel"
											archetypeName="punisher"
											text="They dropped something big and scary behind their tower? No problem. Just bridge-drop a punisher on the other side to break up their push and give them a run for their money. One batch, two batch, penny and dime..."
											color="purpleDescription"/>

					<CardButtonDescription rarity="archetypeDescription"
											titleBackground="commonTitle"
											cardTitle={ "building" }
											className="building"
											cardBackground="inferno-tower"
											archetypeName="building"
											text="Everything is awesome! Follow the instructions as you defend by building a building. Simple enough, right?"
											color="lightBlueDescription"/>
					<div className="cardConnector"/>
          <CardButton rarity="common"
											titleBackground="commonTitle"
											cardTitle={ "building" }
											className="building"
											cardBackground="inferno-tower"
											archetypeName="building" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/DefenseBox.js